export const splitByPoolAvailability = <T extends { slug: string }>(
  craftableCompetitions: readonly T[],
  availableCompetitions: readonly { slug: string }[]
) => {
  const availableSlugs = new Set(availableCompetitions.map(({ slug }) => slug));

  return {
    inPool: craftableCompetitions.filter(({ slug }) =>
      availableSlugs.has(slug)
    ),
    outOfPool: craftableCompetitions.filter(
      ({ slug }) => !availableSlugs.has(slug)
    ),
  };
};
